export const Modules = {
  total: 8
};
